import styled, { css } from 'styled-components';
import { Popup } from '@fluentui/react';
import { Input, Label, Radio } from '@fluentui/react-components';
import { InfoFilled } from '@fluentui/react-icons';
import {
  SecondaryButton,
  PrimaryButton,
} from 'src/styles/globalStyles/buttonStyles.styled';

export const AlertIcon = styled(InfoFilled)`
  transform: rotate(180deg);
  width: 20px;
  height: 20px;
  color: #b10e1c;
`;

export const ErrorMessage = styled.p`
  font-size: 12px !important;
  font-weight: 400;
  color: ${(props) => props.theme.skillsMainTextColor} !important;
`;

export const ErrorMessageContainer = styled.div`
  box-sizing: border-box;
  height: 36px;
  width: 100%;
  border-top: 1px solid ${(props) => props.theme.skillsErrorMessageBorder};
  border-bottom: 1px solid ${(props) => props.theme.skillsErrorMessageBorder};
  background: ${(props) => props.theme.skillsErrorBackground};
  padding: 0px 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  position: absolute;
  top: -36px;

  @media (max-width: 710px) {
    position: static;
    width: 100%;
    height: 52px;
    border-radius: 4px;
    border-right: 1px solid ${(props) => props.theme.skillsErrorMessageBorder};
    border-left: 1px solid ${(props) => props.theme.skillsErrorMessageBorder};
  }
`;

export const AddSkillDivider = styled.div`
  width: 90%;
  height: 1px;
  background-color: ${(props) => props.theme.skillsPopupRadioSectionsDivider};
  margin: auto;
`;

export const HeaderDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.skillsAccordionBorderColor};
`;

export const LabelStyled = styled(Label)`
  font-size: 13px;
  display: inline;
  width: 55px;
  span {
    padding: 0;
    padding-left: 0;
  }

  @media (max-width: 710px) {
    font-size: 14px;
    font-weight: 400;
    width: 75px;
    color: ${(props) => props.theme.skillsLabelColor} !important;
  }
`;

export const RadioButtonWrapper = styled.div`
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 710px) {
    width: 100%;
    label {
      color: #424242 !important;
      font-size: 14px;
      font-weight: 400;
      width: 100%;
      text-align: left;
    }
    div {
      margin-left: 0px;
    }
  }
`;

export const SelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: left;
  align-items: center;
  padding-left: 1.5rem;
  height: 2.5rem;
  position: relative;
  label:first-child {
    width: 52px;
  }
`;

export const SkillsAddBackdrop = styled(Popup)`
  background: ${(props) => props.theme.popupOpacity};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
`;

export const SkillsBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${(props) => props.theme.skillsAccordionBorderColor};
  border-bottom: 1px solid ${(props) => props.theme.skillsAccordionBorderColor};
  position: relative;
`;

export const SkillsDiscardButton = styled(SecondaryButton)`
  min-width: 70px;
`;

export const SkillsSaveButton = styled(PrimaryButton)`
  min-width: 70px;
  margin-left: 5px;
`;

export const SmallAlertIcon = styled(InfoFilled)`
  transform: rotate(180deg);
  width: 14px;
  height: 14px;
  color: ${(props) => props.theme.skillsErrorAlertIconColor};
  position: absolute;
  left: 5px;
`;

const radioButtonErrorStyle = css`
  svg,
  div {
    border-color: ${(props) =>
      props.theme.skillsErrorAlertIconColor} !important;
    color: ${(props) => props.theme.skillsErrorAlertIconColor};
  }
`;

export const RadioButtonStyled = styled(Radio)<{ errorStyle: boolean }>`
  ${({ errorStyle }) => {
    if (errorStyle) {
      return radioButtonErrorStyle;
    }
  }}
  @media (max-width: 710px) {
    label,
    input {
      color: ${(props) => props.theme.skillsLabelColor} !important;
    }
  }
`;

export const EditReadOnlyInput = styled(Input)`
  pointer-events: none;
  width: 100%;
`;

export const AddSkillsBackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5%;
  margin-left: 2rem;

  svg {
    margin: 0 !important;
    color: ${(props) => props.theme.skillsButtonsColor};
  }
`;
